module.exports = __webpack_public_path__ + "img/kiosk-place-de-la-cite-home.9056163d.jpg";